import React, { Component } from 'react';
import '../../../App.css';
import { Link } from 'react-router-dom'

import logo from '../../../img/pioricost-slogan.png'
import es from '../../../img/ecuador.svg'
import ru from '../../../img/russia.svg'
import usa from '../../../img/usa.svg'
import home from '../../home';


class navbar extends Component {
  constructor(props){
    super(props)
    this.state = {
      toggle: 0
    }
  }

  static defaultProps = {
    link1:'',
    link2:'',
    link3:'',
    link4:'',
    link5:'',
    red1: '',
    red2: '',
    red3: '',
    red4: '',
    red5: '',
  }

  toggleMenu = (num)=>{
    this.setState({
        toggle: this.state.toggle ? 0 : num
    })
  }

  render() {
    return (
      <div className="navbar">
        {/* logo */}
        <div>
          <Link to='/'><img src={logo} alt=""/></Link>
        </div>
        {/* menu */}
        <nav id="desktop-nav">
          <span><Link to={this.props.red1}>{this.props.link1}</Link></span>
          <span><Link to={this.props.red2}>{this.props.link2}</Link></span>
          <span><Link to={this.props.red3}>{this.props.link3}</Link></span>
          <span><Link to={this.props.red4}>{this.props.link4}</Link></span>
          <span><Link to={this.props.red5}>{this.props.link5}</Link></span>
        </nav>

        <div id="redes">
          <a href="https://www.facebook.com/pioricost/" target="_blank" className="fa fa-facebook"></a>
          <a href="https://www.instagram.com/pioricostfruitec/" target="_blank" className="fa fa-instagram"></a>
          |
          <Link to="/" className="es" onClick={()=>this.props.buttonClick('ES')}>ES.</Link>
          <Link to="/ru" className="ru" onClick={()=>this.props.buttonClick('RU')}>RU.</Link>
          <Link to="/en" className="en" onClick={()=>this.props.buttonClick('EN')}>EN.</Link>
        </div>

        <i className="fa fa-ellipsis-v" onClick={()=>this.toggleMenu(1)}></i>
        {this.state.toggle === 1 &&
        <div id="desktop-mobile">
          <i className="fa fa-times" onClick={()=>this.toggleMenu(0)}></i>
          <span><Link to={this.props.red1}>{this.props.link1}</Link></span>
          <span><Link to={this.props.red2}>{this.props.link2}</Link></span>
          <span><Link to={this.props.red3}>{this.props.link3}</Link></span>
          <span><Link to={this.props.red4}>{this.props.link4}</Link></span>
          <span><Link to={this.props.red5}>{this.props.link5}</Link></span>
          <div id="redes-mobile">
            <a href="https://www.facebook.com/pioricost/" target="_blank" className="fa fa-facebook"></a>
            <a href="https://www.instagram.com/pioricostfruitec/" target="_blank" className="fa fa-instagram"></a>
            <Link to="/" className="es" onClick={()=>this.props.buttonClick('ES')}>ES.</Link>
            <Link to="/ru" className="ru" onClick={()=>this.props.buttonClick('RU')}>RU.</Link>
            <Link to="/en" className="en" onClick={()=>this.props.buttonClick('EN')}>EN.</Link>
          </div>
        </div>
        }
        
      </div>
    );
  }
}

export default navbar;


// WEBPACK FOOTER //
// ./src/components/reusables/navbar/index.js